module.exports = __webpack_public_path__ + "static/media/watch.75678e62.svg";